module.exports = __webpack_public_path__ + "static/media/PaymentSplitsBySelected.dbfa5eef.png";